const jboardQname = [
  {qname: 'jujue.tv', qcode: null, qdigit: null},
  {qname: 'jujue.tv', qcode: null, qdigit: null},
  {qname: 'jujue.tv', qcode: null, qdigit: null}
];

export default jboardQname;
